export default "__VITE_ASSET__077d93aa__"